import { useState, useEffect, createContext, useRef } from "react";
import Alert from "@mui/material/Alert";
import { toast } from "react-toastify";
import { NetNewHeader } from "./NetNewHeader";
import { NetNewBody } from "./NetNewBody";
import "./NetNewAccount.css";

export const NetNewContext = createContext();

// view-source:https://b2unifiedview.bamboobox.ai/#/filter/%5B%7B%22key%22%3A%7B%22index%22%3A2%7D%2C%22attrId%22%3A%22E63kyu2eapdehvn52J%22%2C%22attribute%22%3A%22Intent%20Level%22%2C%22type%22%3A%22INTENT%22%2C%22relation%22%3A%22includes%22%2C%22values%22%3A%5B%22VERY%20HIGH%22%5D%7D%5D/analytics_dashboard/%5B%5D?icp=ccaas&segmentName=All%20Accounts&newDashboard=true&tabVal=2&category=Intent
const generateLink = (icp, segment, tabVal, intentLevel, source, fromDate, toDate) => {
  const categoryArr = ["Data Quality and Coverage", "Engagement", "Intent", "Potential Opportunity", "Deal", "Customer"];
  const icpSelected = icp || "";
  const segmentName = segment;
  const category = categoryArr[tabVal];
  let dynamicFilterArr = [];

  if (intentLevel?.length) {
    dynamicFilterArr.push({
      attrId: "E63kyu2eapdehvn52I",
      attribute: "buyer_interest_level",
      label: "Buyer Interest Level",
      type: "new_accounts_agg",
      relation: "includes",
      values: [intentLevel.toUpperCase()],
    });
  }
  if (source?.length) {
    dynamicFilterArr.push({
      attrId: "E63kyu2eapdehvn52J",
      attribute: "sources",
      label: "Source",
      type: "new_accounts_agg",
      relation: "includes",
      values: [source.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())],
    });
  }
  if (fromDate && toDate) {
    dynamicFilterArr.push({
      attrId: "E63kyu2eapdehvn52k",
      attribute: "last_event_date",
      relation: "between",
      label: "Last Event Date",
      type: "new_accounts_agg",
      values: [fromDate, toDate.toISOString().split("T")[0]+"T00:00:00.000Z"],
    });
  }

  return `${window._env_.UNIFIED_FRONTEND_URL}/#/filter/${encodeURIComponent(encodeURIComponent(JSON.stringify(dynamicFilterArr)))}/analytics_dashboard/${encodeURIComponent(
    encodeURIComponent(JSON.stringify([]))
  )}/?icp=${icpSelected}&segmentName=${segmentName}&tabVal=${tabVal}&attribute=${""}&category=${category}&newDashboard=true&netNewHub=true`;
};
function GetDateFrom() {
  let date = sessionStorage.getItem("oldDate") || new Date();
  return new Date(date);
}
export const NetNewAccount = (props) => {
  const controllerRef = useRef(null);
  const { tenantId, icpSelected, segmentName, tabVal } = props;

  const [data, setData] = useState(undefined);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [selectedFrequency, setSelectedFrequency] = useState("Weekly");
  const [fromDate, setFromDate] = useState(GetDateFrom());
  const [toDate, setToDate] = useState(new Date());

  const setPreviewTableData = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    const controller = new AbortController();
    controllerRef.current = controller;
    fetch(`${window._env_.UNIFIED_URL}/analytics/intent/get-new-account?tenantId=${tenantId}&icp=${icpSelected}&startDate=${fromDate}&endDate=${toDate}`, {
      method: "GET",
      headers: {
        // "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      credentials: "include",
      signal: controller.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        if (res?.data) {
          setData(res.data);
          setTotalCount(res.count);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.log("Preview API call aborted");
          return;
        }
        setData([]);
        setIsLoading(false);
        toast.error(<Alert severity="warn">Error Occurred while retrieving data</Alert>, {
          closeOnClick: true,
          autoClose: true,
          closeButton: true,
          newestOnTop: true,
        });
      });
  };

  useEffect(() => {
    if (icpSelected) {
      setIsLoading(true);
      setPreviewTableData();
    }
  }, [icpSelected, toDate, fromDate]);

  return (
    <>
      <div className="net-new-root-container">
        <NetNewContext.Provider
          value={{
            tenantId,
            icpSelected,
            segmentName,
            tabVal,
            isLoading,
            setIsLoading,
            data,
            totalCount,
            selectedFrequency,
            setSelectedFrequency,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            generateLink,
          }}
        >
          <NetNewHeader />
          <NetNewBody isLoading={isLoading} setIsLoading={setIsLoading} />
        </NetNewContext.Provider>
      </div>
    </>
  );
};
